export var DEFAULT_ERROR_MESSAGE = "Não foi possível se comunicar com o servidor, tente novamente mais tarde.";
